import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirmation-release',
  templateUrl: './confirmation-release.component.html',
  styleUrls: ['./confirmation-release.component.scss']
})
export class ConfirmationReleaseComponent implements OnInit {

  /**
   * Constructor
   *
   * @param {MatDialogRef<ConfirmationReleaseComponent>} matDialogRef
   * @param _data
   */
  disabledButton:boolean;
  constructor(
    public matDialogRef: MatDialogRef<ConfirmationReleaseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onNoClick(data?): void {  
    this.disabledButton = true;  
    this.matDialogRef.close(data);
  }

}
